export default __webpack_public_path__ + "static/media/chat.2a123942.svg";